import { Box, Typography } from '@mui/material';
import { styled } from '@mui/system';

const VersionContainer = styled(Box)(({ theme }) => ({
  position: 'fixed',
  bottom: 0,
  right: 0,
  padding: theme.spacing(1, 2),
  zIndex: 1,
  backgroundColor: 'transparent',
  pointerEvents: 'none',
}));

const VersionText = styled(Typography)(({ theme }) => ({
  fontSize: '0.75rem',
  color: theme.palette.text.disabled,
  fontFamily: theme.typography.fontFamily,
  userSelect: 'none',
}));

function Version() {
  const version = process.env.REACT_APP_VERSION || '0.0.0';
  return (
    <VersionContainer>
      <VersionText variant="caption">v{version}</VersionText>
    </VersionContainer>
  );
}

export default Version;
